/* eslint-disable no-console */
class BrowserPopup {
  constructor() {
    // Bind class methods
    this.init = this.init.bind(this);

    // Bind class properties
    this.triggerSelector = '[aria-controls="modal-unsupported-browser"]';
    this.messageKey = 'unsupported-browser-message-seen';
    this.testKey = 'unsupported-browser-storage-test';

    // Initialize component on load
    document.addEventListener('DOMContentLoaded', this.init);
  }

  init() {
    this.trigger = document.querySelector(this.triggerSelector);

    if (this.trigger) {
      if (this.storageAvailable() && !localStorage.getItem(this.messageKey)) {
        this.trigger.click();
        localStorage.setItem(this.messageKey, true);
      }
    }
  }

  storageAvailable() {
    try {
      localStorage.setItem(this.testKey, true);
      localStorage.removeItem(this.testKey);
      return true;
    } catch (e) {
      return false;
    }
  }
}

export default BrowserPopup;
